// Accordions behaviour
// Based on:
// - https://design-system.w3.org/components/collapsible-containers.html
// - https://github.com/w3c/w3c-website-templates-bundle/blob/main/assets-src/js/main/collapsibles.js
// - https://css-tricks.com/using-css-transitions-auto-dimensions/#aa-technique-3-javascript
export default document.addEventListener('DOMContentLoaded', () => {
  const accordions = document.querySelectorAll('.js-accordion')

  if (!accordions.length > 0) {
    return
  }

  // Loop through containers
  accordions.forEach((item) => {
    // Get headings inside a collapsible container
    const headingsArray = Array.prototype.slice.call(
      item.querySelectorAll('.js-accordion-heading')
    )

    // Loop through headings
    headingsArray.forEach((heading) => {
      // Insert a button for opening/closing the collapsible section
      // eslint-disable-next-line no-param-reassign
      heading.innerHTML = `<button class="accordion__button" aria-expanded="false">
            ${heading.innerHTML}
          </button>`

      // Get the panel element
      const panel = heading.nextElementSibling
      // Add appropriate aria role
      panel.setAttribute('aria-hidden', 'true')
      // Set the initial height
      panel.style.height = '0px'
      // Get focusable elements
      const focusableChildren = panel.querySelectorAll(
        'a[href], button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])'
      )
      // Make them non-focusable
      focusableChildren.forEach((childElement) => {
        childElement.setAttribute('tabindex', '-1')
      })

      // Assign the button
      const btn = heading.querySelector('button')

      // Add click event listener
      btn.addEventListener('click', () => {
        // Cast the state as a boolean
        const expanded = btn.getAttribute('aria-expanded') === 'true'

        // Get the height of the element's inner content, regardless of its actual size
        const sectionHeight = panel.scrollHeight

        // Expanded > Collapsed
        if (expanded) {
          // temporarily disable all css transitions
          const elementTransition = panel.style.transition
          panel.style.transition = ''

          // on the next frame (as soon as the previous style change has taken effect),
          // explicitly set the panel's height to its current pixel height, so we
          // aren't transitioning out of 'auto'
          requestAnimationFrame(() => {
            panel.style.height = `${sectionHeight}px`
            panel.style.transition = elementTransition

            // on the next frame (as soon as the previous style change has taken effect),
            // have the element transition to height: 0
            requestAnimationFrame(() => {
              panel.style.height = '0px'
            })
          })
          // Collapsed > Expanded
        } else {
          // have the element transition to the height of its inner content
          panel.style.height = `${sectionHeight}px`

          // when the next css transition finishes (which should be the one we just triggered)
          panel.addEventListener(
            'transitionend',
            () => {
              // remove "height" from the panel's inline styles, so it can return to its initial value
              panel.style.height = null
            },
            { once: true }
          )
        }

        // Switch the state
        btn.setAttribute('aria-expanded', expanded ? 'false' : 'true')

        // Switch the collapsible section's visibility
        panel.setAttribute('aria-hidden', expanded ? 'true' : 'false')
        // Make children focusable / non-focusable
        focusableChildren.forEach((childElement) => {
          if (expanded) {
            childElement.setAttribute('tabindex', '-1')
          } else {
            childElement.removeAttribute('tabindex', '-1')
          }
        })
      })
    }) // End loop
  })
})
